import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { Box, Typography, Button, TextField, Container, CircularProgress, useMediaQuery, useTheme } from '@mui/material';
import './Register.css';

const Register = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const handleRegister = async () => {
    if (password !== confirmPassword) {
      setError('Le password non coincidono');
      return;
    }
    setIsLoading(true);
    try {
      await setPersistence(auth, browserLocalPersistence);
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      // Crea il documento utente in Firestore
      const userDocRef = doc(db, 'users', user.uid);
      await setDoc(userDocRef, {
        name: name,
        email: email,
        photoURL: '', // puoi inserire un'immagine di default
        lastLogin: new Date(),
        acceptedTerms: false
      });
      // Dopo la registrazione, reindirizza alla pagina dei termini o alla dashboard
      navigate('/terms-and-conditions');
    } catch (err) {
      console.error('Errore durante la registrazione:', err);
      setError('Errore durante la registrazione: ' + err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4, p: 3, backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
        <Typography variant="h4" align="center" gutterBottom>
          Registrati
        </Typography>
        {error && (
          <Typography variant="body2" color="error" align="center">
            {error}
          </Typography>
        )}
        <TextField
          fullWidth
          label="Nome"
          variant="outlined"
          margin="normal"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          fullWidth
          label="Conferma Password"
          type="password"
          variant="outlined"
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleRegister}
          disabled={isLoading}
          sx={{ mt: 2, padding: '12px 0', textTransform: 'none', fontSize: '1rem' }}
        >
          {isLoading ? <CircularProgress size={24} /> : 'Registrati'}
        </Button>
        <Box mt={2} textAlign="center">
          <Typography variant="body2">
            Hai già un account?{' '}
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate('/')}
              sx={{ textTransform: 'none', fontWeight: 'bold' }}
            >
              Accedi
            </Button>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Register;
